import { attachSwipeEvents, throttle } from '../../utils';

const Drawer = () => {
  const drawers = document.querySelectorAll('.js-drawer');

  for (const drawer of drawers) {
    const toggles = drawer.querySelectorAll('.js-drawer-toggle');
    const backdrop = drawer.querySelector('.js-drawer-backdrop');
    const panel = drawer.querySelector('.js-drawer-panel');

    if (!toggles.length || !panel) {
      continue;
    }

    const open = () => {
      drawer.classList.add('-open');

      for (const t of toggles) {
        t.setAttribute('aria-expanded', 'true');
        t.setAttribute('aria-label', 'Fermer le panneau');
      }

      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      drawer.classList.remove('-open');

      for (const t of toggles) {
        t.setAttribute('aria-expanded', 'false');
        t.setAttribute('aria-label', 'Ouvrir le panneau');
      }

      document.body.style.overflow = '';
    };

    const toggleDrawer = () => {
      if (drawer.classList.contains('-open')) {
        close();
      } else {
        open();
      }
    };

    for (const t of toggles) {
      t.addEventListener('click', toggleDrawer);
    }

    if (backdrop) {
      backdrop.addEventListener('click', close);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('-open')) {
        close();
        toggles[0].focus();
      }
    });

    attachSwipeEvents(panel, {
      onSwipeDown: close,
      onSwipeUp: () => {
        if (!drawer.classList.contains('-open')) {
          open();
        }
      },
    });

    const SM_MAX = 900;

    const resizeHandler = () => {
      if (window.innerWidth > SM_MAX && drawer.classList.contains('-open')) {
        close();
      }
    };

    window.addEventListener('resize', throttle(resizeHandler, 100));
  }
};

export default Drawer;
